import React from 'react';
import { Button } from './ui/button';

const RatingControl = ({ value, onChange, testId }) => {
  const ratings = [1, 2, 3, 4, 5];

  return (
    <div className="flex gap-2" data-testid={testId}>
      {ratings.map((rating) => (
        <Button
          key={rating}
          type="button"
          onClick={() => onChange(rating)}
          variant={value === rating ? "default" : "outline"}
          size="sm"
          className={`
            w-10 h-10 rounded-sm transition-colors duration-200
            ${value === rating 
              ? 'bg-[#1E40AF] hover:bg-[#1E3A8A] text-white border-[#1E40AF]' 
              : 'border-slate-200 hover:bg-slate-50 text-slate-700'
            }
          `}
          data-testid={`${testId}-option-${rating}`}
        >
          {rating}
        </Button>
      ))}
    </div>
  );
};

export default RatingControl;
